<p-modal [open]="open" (dismiss)="close()">
  <p-heading slot="header" [size]="'large'" [tag]="'h2'">
    Are you sure you want to delete {{ remoteUserLocation?.description }} remote user location?
  </p-heading>

  <p-text>This action cannot be undone. Please confirm that you want to proceed.</p-text>

  <p-button-group slot="footer">
    <p-button (click)="close()">Cancel</p-button>

    <p-button [loading]="(submitting$ | async) ?? false" [variant]="'secondary'" (click)="submit()">
      Delete Remote User Location
    </p-button>
  </p-button-group>
</p-modal>
